/* TIME PARK — scroll animations + product filter tabs */
(function () {
  'use strict';

  /* Scroll-in animation (replicates the original site's data-aos behavior) */
  function observeAOS() {
    if (!('IntersectionObserver' in window)) {
      document.querySelectorAll('.tp-aos').forEach(function (el) { el.classList.add('tp-aos-animate'); });
      return;
    }
    var obs = new IntersectionObserver(function (entries) {
      entries.forEach(function (e, i) {
        if (e.isIntersecting) {
          setTimeout(function () { e.target.classList.add('tp-aos-animate'); }, i * 90);
          obs.unobserve(e.target);
        }
      });
    }, { threshold: 0.08 });
    document.querySelectorAll('.tp-aos:not(.tp-aos-animate)').forEach(function (el) { obs.observe(el); });
  }

  /* Client-side product filter tabs (by product type) */
  function initFilters() {
    document.querySelectorAll('[data-tp-filters]').forEach(function (wrap) {
      var grid = document.getElementById(wrap.getAttribute('data-tp-filters'));
      if (!grid) return;
      wrap.addEventListener('click', function (ev) {
        var btn = ev.target.closest('.tp-filter-tab');
        if (!btn) return;
        wrap.querySelectorAll('.tp-filter-tab').forEach(function (t) { t.classList.remove('active'); });
        btn.classList.add('active');
        var type = btn.getAttribute('data-filter');
        grid.querySelectorAll('.tp-product-card').forEach(function (card) {
          card.style.display = (type === 'all' || card.getAttribute('data-cat') === type) ? '' : 'none';
        });
      });
    });
  }

  function init() {
    observeAOS();
    initFilters();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  /* Re-run for Shopify theme editor section reloads */
  document.addEventListener('shopify:section:load', init);
})();
